import { Flex, Text, Image, Center } from "@chakra-ui/react";
import { UserLogout } from "app/users";
import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { SIDEMENU_NAVIGATION } from "./constants";
import SideMenuNav from "./SideMenuNav";
import logo from "../assets/logo.png";

export const SideMenu: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Flex width={"100%"} maxWidth={["sideMenu"]} flexDir="column">
      {/* LOGO */}
      <Center>
        <NavLink to="/">
          <Image height="100px" src={logo} alt="Rideal logo" />
        </NavLink>
      </Center>
      <Center>
        <Text variant="logo-text">Control Center</Text>
      </Center>
      {/* SUBMENU */}
      <Flex flexDir="column" justifyContent="space-between" height="100%">
        <SideMenuNav
          activeItemId={location.pathname}
          onSelect={({ itemId }) => {
            navigate(itemId);
          }}
          items={SIDEMENU_NAVIGATION}
        />
        <UserLogout />
      </Flex>
    </Flex>
  );
};
